export { ClaimInfoView } from "./ClaimInfoView";
